export const resourceManagementPaths = {
  RESOURCE_MANAGEMENT: "",
  RESOURCE: "resource",
  RESOURCE_CREATE: "resource/create",
  RESOURCE_EDIT: "resource/:id",
  RESOURCE_ID: (id) => `resource/${id}`,
  RESOURCE_DELETE: "resource/delete/:id",
  RESOURCE_DELETE_ID: (id) => `resource/delete/${id}`,
  RESOURCE_INSIGHTS: "resource-insights",

  SECTION: "section",
  SECTION_CREATE: "section/create",
  SECTION_EDIT: "section/:id",
  SECTION_ID: (id) => `section/${id}`,
  SECTION_DELETE: "section/delete/:id",
  SECTION_DELETE_ID: (id) => `section/delete/${id}`,

  RESOURCETYPE: "resourcetype",
  RESOURCETYPE_CREATE: "resourcetype/create",
  RESOURCETYPE_EDIT: "resourcetype/:id",
  RESOURCETYPE_ID: (id) => `resourcetype/${id}`,
  RESOURCETYPE_DELETE: "resourcetype/delete/:id",
  RESOURCETYPE_DELETE_ID: (id) => `resourcetype/delete/${id}`,
};
